import { useQuery } from '@tanstack/react-query';
import { fetchShipmentItrackStatus } from '../data-provider/shipment-itrack-status';

export const useGetShipmentItrackStatus = () => {
  return useQuery({
    queryKey: ['shipment-itrack-status'],
    queryFn: () => fetchShipmentItrackStatus(),
    staleTime: 1000 * 60 * 60 * 24, // 1 day
  });
};
